<template>
  <div>
    <b-card no-header>
      <b-row>
        <b-col cols="12" md="6">
          <h5>Informasi Sekolah</h5>
          <template v-for="(m, index) in filterModel(['school_name', 'kepsek', 'npsn', 'bendahara', 'total_student'])">
            <div :key="'informasi_sekolah_' + index">
              <detail-group-input
                :ref="index"
                :type="m.type"
                :label="typeof m.label === 'string' ? m.label : null"
                :need-label="true"
                v-model="m.value"
                :id="index"
              />
            </div>
          </template>
        </b-col>
        <b-col cols="12" md="6">
          <h5>Informasi Akun</h5>
          <template v-for="(m, index) in filterModel(['name', 'username', 'email'])">
            <div :key="'informasi_akun_' + index">
              <detail-group-input
                :ref="index"
                :type="m.type"
                :label="typeof m.label === 'string' ? m.label : null"
                :need-label="true"
                v-model="m.value"
                :id="index"
              />
            </div>
          </template>
        </b-col>
        <!-- <b-col cols="12" md="6">
          <h5>Informasi Tugas</h5>
          <template v-for="(m, index) in filterModel(['role', 'username', 'dapil_id', 'work_area_city_id', 'work_area_district_id', 'work_area_village_id', 'tps'])">
            <div :key="'tugas_' + index">
              <detail-group-input :ref="index" :type="m.type" :label="typeof m.label === 'string' ? m.label : null" :need-label="true" v-model="m.value" :id="index" />
            </div>
          </template>
        </b-col> -->
      </b-row>
      <div>
        <b-button
          :to="'/sekolah/' + $route.params.id + '/edit'"
          variant="primary"
          class="mt-0"
          >Ubah</b-button
        >
        <b-button :to="'/sekolah/'" variant="secondary" class="ml-3 float-right"
          >Kembali</b-button
        >
      </div>
    </b-card>
  </div>
</template>

<script>
import { setModelValue } from "@/_helpers";
import detailGroupInput from "@/components/DetailGroupInput.vue";
import School from "@/models/School.js";

const schoolModel = new School();

export default {
  components: {
    detailGroupInput,
  },
  watch: {
    "$route.params.id": function (val) {
      if (val !== undefined) {
        this.getDetail();
      }
    },
  },
  data() {
    return {
      isLoading: false,
      model: schoolModel.init(),
    };
  },
  mounted() {
    this.model.password.type = "hidden";
    this.getDetail();
  },
  methods: {
    filterModel(search) {
      const filtered = Object.entries(this.model).filter((mdl) => {
        return search.includes(mdl[0]);
      });
      let result = {};
      filtered.forEach((element) => {
        result[element[0]] = element[1];
      });
      return result;
    },
    getDetail() {
      this.isLoading = true;
      schoolModel
        .find(this.$route.params.id, {
          detail: 1,
        })
        .then((resp) => {
          this.isLoading = false;
          let response = {};
          Object.keys(resp).forEach((key) => {
            if (! ['name', 'username', 'email'].includes(key)) {
              response[key] = resp[key];
            }
          })
          Object.keys(resp.admin).forEach((key) => {
            response[key] = resp['admin'][key];
          })
          // response["phone_number"] = response["phone_number"].replace(
          //   "+62",
          //   "0"
          // );
          setModelValue(this.model, response);
        })
        .catch((error) => {
          if (process.env.NODE_ENV !== "production") {
            console.error(error);
          }
          this.isLoading = false;
        });
    },
  },
};
</script>